import { useState, useEffect } from "react";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL as string;

interface GameweekResponse {
  id: number;
}

export function useCurrentGameweek() {
  const [currentGameweek, setCurrentGameweek] = useState<number | null>(null);
  const [selectedGameweek, setSelectedGameweek] = useState<number | null>(null);
  const [gwError, setGWError] = useState<string | null>(null);

  useEffect(() => {
    const getGameweekInformation = async () => {
      try {
        const response = await axios.get<GameweekResponse>(
          `${API_BASE_URL}/api/current-gameweek`
        );
        const gameweek = response.data.id;
        setCurrentGameweek(gameweek);
        setSelectedGameweek(prev => (prev == null ? gameweek : prev));
      } catch (err) {
        setGWError("Failed to fetch transfers");
      }
    };

    getGameweekInformation();
  }, []);

  return { currentGameweek, selectedGameweek, gwError, setSelectedGameweek };
}
